module.exports = __webpack_public_path__ + "mulcovaci-kura0-80.jpg?26bc70f0fa93adf9b85c9f37d5063d7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/mulcovaci-kura0-80.jpg
// module id = 82
// module chunks = 0